import React from 'react'
import getConfig from 'next/config'

import { style } from '../../../components/Common/Index.style'
import { no162Style } from '../../../components/Article/No162.style'
import Page from '../../../components/Page/Page'
import PageHeader from '../../../components/PageHeader/PageHeader'
import Content from '../../../components/Content/Content'
import SectionTitle from '../../../components/SectioinTitle'
import BackBtn from '../../../components/Common/BackBtn'
import BreadCrumb from '../../../components/Breadcrumbs/Breadcrumbs'

const { publicRuntimeConfig } = getConfig()
const basePath = publicRuntimeConfig.basePath

const pageTitle = '令和5年度 当初予算 | 新潟県民だより'

const Home = () => {
  return (
    <Page title={pageTitle}>
      <PageHeader pageTitle="特集" />
      <SectionTitle sectionTitle="令和5年度 当初予算" />
      <Content css={style.content}>
        <BreadCrumb
          lists={[
            {
              name: "HOME",
              path: "/"
            },
            {
              name: "2023春号 No.162 目次",
              path: "/no162"
            },
            {
              name: "特集"
            }
          ]}
        />

        <img
          src={`${basePath}/no162/img/1-1.png`}
          alt="令和5年度 当初予算"
          css={style.img(0)}
        />

        
        <h3 css={style.subTitle01}>「子育てに優しい新潟」の実現に向けて</h3>
        
        <img
          src={`${basePath}/no162/img/1-2.png`}
          alt="新潟県知事　花角英世"
          css={style.img(250)}
        />
        <p>新潟県知事&emsp;花角英世</p>
        <p>やわらかな春の日差しが心地よい季節となり、新年度がスタートしました。<br />始めに、今冬の豪雪による除雪作業中の事故等により被害に遭われた皆様に心からお悔やみとお見舞いを申し上げますとともに、車両滞留や停電への対応における関係機関の皆様の御協力・御尽力に、改めて感謝申し上げます。<br />さて、令和5年度当初予算では、物価高騰や昨年8月の大雨災害からの復旧事業、新型コロナウイルス感染症への対応等、足元の課題にしっかり対応するとともに、本県の中長期的な成長・発展に向け、3つの重要な取組である「脱炭素社会への転換」「デジタル改革の実行」「分散型社会への対応」を進めてまいります。<br />なかでも「分散型社会への対応」に関連し、若い世代の方々に「新潟県」を選んで住んでもらう、働いてもらう、あるいは新しいことに挑戦してもらうために、特に子育ての環境整備に大きく力を入れています。市町村や民間団体等とも連携しながら、結婚から妊娠・出産・子育てまで切れ目のない支援を実施し、社会全体で子育てを祝福し、応援する環境づくりを進め、「子育てに優しい新潟」の実現に向け取り組んでまいります。<br />あわせて、防災・減災対策、起業・創業支援、健康づくりの推進や医療の充実、交流人口の拡大等の重要課題についても引き続き対応してまいります。<br />また、これまでの行財政改革の取組により、令和5年度予算の収支均衡など行動計画の目標を達成できる見込みとなりました。県民の皆様の御協力に改めて感謝申し上げます。一方、この先の経済情勢等によっては財政状況の変動も想定されるため、今後も持続可能な財政運営の実現に向け取り組んでまいります。<br />多くの方から魅力ある県として選ばれるよう「住んでよし、訪れてよしの新潟県」づくりをさらに推進してまいります。</p>
        
        
        
        <h3 css={style.subTitle01}>令和5年度当初予算特集「住んでよし、訪れてよしの新潟県」の実現に向けて</h3>
        
        <img
          src={`${basePath}/no162/img/2-1.png`}
          alt="イラスト"
          css={style.img(200)}
        />
        
        <h4 css={style.subTitle02}>「住んでよし、訪れてよしの新潟県」づくりを加速させる予算</h4>
        <p css={no162Style.strongCatch}>令和5年度の県予算&emsp;1兆3,429億円</p>
        
        <h4 css={style.subTitle02}>歳出のポイント</h4>
        
        <ul css={no162Style.listDisc}>
        <li>県民生活や県内経済が直面する足元の課題へ適切に対応</li>
        <li>本県の中長期的な成長·発展に向けた取組を深化させるとともに、子育て支援の取組を強化</li>
        <li>本県の重点的な取組を13の政策パッケージにして積極的に推進</li>
        </ul>
        
        <img
          src={`${basePath}/no162/img/2-2.png`}
          alt="歳入の内訳"
          css={style.img(500, "20px 0 20px 0")}
        />
        
        <img
          src={`${basePath}/no162/img/2-3.png`}
          alt="歳出の内訳"
          css={style.img(500, "20px 0 20px 0")}
        />
        
        <p>紙面では、主な取組を紹介しています。<br />詳しくは
          <a
            href="https://www.pref.niigata.lg.jp/sec/zaisei/r5tousho.html"
            target="_blank"
            rel="noreferrer"
          >
            <span>県ホームページ</span>
          </a>
          をご覧ください。
        </p>
        
        <p>問い合わせ&emsp;財政課&emsp;電話：<a href="tel:025-280-5037">025-280-5037</a></p>
        
        
        <h3 css={style.subTitle01}>中長期的な成長・発展に向けた取組</h3>
        
        <div>
        <img
          src={`${basePath}/no162/img/2-4.png`}
          alt="イラスト"
          css={style.img(200)}
        />
        </div>
        
        
        <br />
        <h4 css={style.subTitle02}>分散型社会への対応</h4>
        
        <img
          src={`${basePath}/no162/img/2-5.png`}
          alt="SDGsアイコン"
          css={style.img(157)}
        />
        
        <p>「選ばれる新潟」をキーワードに、働く場所として、チャレンジする場所として、そして訪れる場所として、若い世代を中心に多くの方々から新潟を選んでいただけるよう、しっかりと新潟の魅力を発信するとともに、子育て環境の整備、U・Iターンの促進、働く環境の整備等に取り組みます。</p>
        
        <h5 css={style.subTitle03}>子育てに優しい社会の実現<br />～結婚から妊娠・出産・子育てまで切れ目のない支援の実施～</h5>
        
        <ul css={no162Style.listDisc}>
        <li><span css={style.emphasisWeight}>結婚や子育て等を応援するための基金の創設</span>&emsp;<span css={no162Style.yosan}>10億円</span><br />新たに、結婚時の支援に加え、出生時に、その後の子育ての節目節目の負担軽減につながる支援を行うための基金を創設。</li>
        <li><span css={style.emphasisWeight}>結婚新生活を支援する事業（新居の家賃、引越費用等への支援）を行う市町村に対する補助の実施</span>&emsp;<span css={no162Style.yosan}>6,000万円</span></li>
        <li><span css={style.emphasisWeight}>子育てを後押しする「子育て応援プラス」の展開</span><br />子ども連れの方を対象とした県立美術館·博物館の観覧を無料にする「親子ふれあいデー」の設定&emsp;<span css={no162Style.yosan}>345万円</span>など</li>
        </ul>
        
        <img
          src={`${basePath}/no162/img/2-6.png`}
          alt="イラスト"
          css={style.img(200)}
        />
        
        
        <h5 css={style.subTitle03}>U・Iターン施策の推進</h5>
        <ul css={no162Style.listDisc}>
        <li><span css={style.emphasisWeight}>東京23区から本県に移住する方への支援金給付</span>&emsp;<span css={no162Style.yosan}>1億9,556万円</span></li>
        </ul>
        
        <h5 css={style.subTitle03}>企業誘致の促進</h5>
        <ul css={no162Style.listDisc}>
        <li><span css={style.emphasisWeight}>充実した初期投資支援等を通じたIT関連企業の誘致促進</span>&emsp;<span css={no162Style.yosan}>3億4,589万円</span></li>
        <li><span css={style.emphasisWeight}>県内製造拠点の新設・増設支援による製造業の立地促進</span>&emsp;<span css={no162Style.yosan}>14億6,225万円</span></li>
        </ul>
        
        <br />
        <h4 css={style.subTitle02}>脱炭素社会への転換</h4>
        
        <img
          src={`${basePath}/no162/img/2-7.png`}
          alt="SDGsアイコン"
          css={style.img(405)}
        />
        
        <p>令和4年3月に策定した「新潟県2050年カーボンゼロの実現に向けた戦略」を踏まえ、脱炭素社会への転換に向け、官民一体となり各部門において再エネ・脱炭素燃料等の「創出」、「活用」、CO<sub>2</sub>排出の「削減」、「吸収・貯留」の具体的な取組を進めます。</p>
        
        <ul css={no162Style.listDisc}>
        <li><span css={style.emphasisWeight}>市町村と連携した雪国型ZEH（ゼッチ）等の導入に対する補助の実施</span>&emsp;<span css={no162Style.yosan}>1億2,790万円</span></li>
        <li><span css={style.emphasisWeight}>県有施設への太陽光発電設備の導入</span>&emsp;<span css={no162Style.yosan}>2億7,498万円</span></li>
        <li><span css={style.emphasisWeight}>洋上風力の導入に向けた港湾の施設整備</span>&emsp;<span css={no162Style.yosan}>4,390万円</span></li>
        <li><span css={style.emphasisWeight}>農業分野におけるカーボンニュートラル実現に向けた技術開発・モデル産地育成</span>&emsp;<span css={no162Style.yosan}>5,631万円</span></li>
        <li><span css={style.emphasisWeight}>中小企業の脱炭素化を後押しする相談窓口の設置</span>&emsp;<span css={no162Style.yosan}>498万円</span></li>
        </ul>
        
        <br />
        <h4 css={style.subTitle02}>デジタル改革の実行</h4>
        
        <img
          src={`${basePath}/no162/img/2-8.png`}
          alt="SDGsアイコン"
          css={style.img(239)}
        />
        
        <p>オンライン診療の実証や電子書籍システムの導入をはじめとする暮らしのDXを推進するとともに、県内経済界とともに策定した「県内産業デジタル化構想」の下、県内の各産業が有する課題に応じたDXを強力に推進します。<br />また、「デジタル改革の実行方針」を踏まえ、行政サービスの利便性向上に寄与する行政のDXに取り組みます。</p>
        
        <img
          src={`${basePath}/no162/img/2-9.png`}
          alt="イラスト"
          css={style.img(200)}
        />
        
        <ul css={no162Style.listDisc}>
        <li><span css={style.emphasisWeight}>へき地におけるオンライン診療モデル事業の実施</span>&emsp;<span css={no162Style.yosan}>4,315万円</span></li>
        <li><span css={style.emphasisWeight}>離島・中山間地域における高校等の教育環境の充実に向けた遠隔教育の推進</span>&emsp;<span css={no162Style.yosan}>1,191万円</span></li>
        <li><span css={style.emphasisWeight}>新潟米・園芸の省力化・生産性向上に寄与するスマート農業の推進</span>&emsp;<span css={no162Style.yosan}>5,659万円</span></li>
        <li><span css={style.emphasisWeight}>除雪パトロール作業の効率化・省力化の推進</span>&emsp;<span css={no162Style.yosan}>5,300万円</span></li>
        <li><span css={style.emphasisWeight}>市町村と連携した行政手続のオンライン化の推進</span>&emsp;<span css={no162Style.yosan}>8,136万円</span></li>
        </ul>
        
        
        <h3 css={style.subTitle01}>県民生活や県内経済が直面する足元の課題への対応</h3>
        <p>原油価格・物価高騰等の影響を受けている県内事業者や生活に窮する方々を支援するとともに、昨夏以降の大雨災害や鳥インフルエンザへの対応、新型コロナウイルス感染症対策にしっかりと取り組みます。</p>
        
        <img
          src={`${basePath}/no162/img/2-11.png`}
          alt="イラスト"
          css={style.img(400)}
        />
        
        <h3 css={style.subTitle01}>主な政策パッケージ</h3>
        
        <h4 css={style.subTitle02}>一段加速した防災・減災対策の推進</h4>
        <p>近年、全国的に自然災害が頻発化・激甚化している状況を踏まえ、国の補助金などの有利な財源を活用しながら、ハード・ソフト両面での防災·減災対策を推進します。</p>
        
        <h4 css={style.subTitle02}>地域医療の確保と「健康立県」の実現</h4>
        <p>誰もが安心して医療を受けられる地域医療の確保に取り組むとともに、健康寿命が全国トップクラスの「健康立県」の実現を目指し、県民の健康づくりを推進します。</p>
        
        <h4 css={style.subTitle02}>起業·創業の推進</h4>
        <p>スタートアップ拠点を核として官民連携により起業・創業を支援するほか、地域経済を支える中小企業の事業承継を支援します。</p>
        
        <h4 css={style.subTitle02}>多様な地域資源を活かした交流人口の拡大</h4>
        <p>本県の観光ブランドの定着に向けた取組を引き続き推進するとともに、多様な地域文化やスポーツを活かした交流人口の拡大を推進するほか、「佐渡島（さど）の金山」の世界遺産登録への期待の高まりを踏まえた交流拡大などに取り組みます。</p>
        
        <h3 css={style.subTitle01}>行財政改革行動計画に基づく歳出歳入改革の取組</h3>
        <h4 css={style.subTitle02}>令和5年度当初予算編成での取組状況</h4>
        <p>前年度当初予算と比較して、一般財源ベースで40億円の収支改善を達成しました。</p>
        
        <h4 css={style.subTitle02}>今後の財政収支見通し</h4>
        <p>令和5年度の収支均衡など行財政改革行動計画の目標達成に加え、令和13年度をピークとする公債費の実負担の大幅な増加にも対応できる見通しとなりました。<br />ただし、今後の経済状況等によっては収支の大きな変動が想定されることから、引き続き、持続可能な財政運営の実現に向けてしっかりと取り組みます。</p>
        
        <p>（※行財政改革行動計画の計画期間最終年度である令和5年度に、行財政改革行動計画の総括と令和6年度以降の取組について検討を行います。）</p>
        
        <br />
        <div>
        <img
          src={`${basePath}/no162/img/2-10.png`}
          alt="SDGsロゴ"
          css={style.img(400)}
        />
        </div>
        
        <p>県が率先してSDGs（持続可能な開発目標）達成に向けた取組を進めていくため、「新潟県庁SDGs行動宣言」を策定し、各種施策の実施に当たっては、SDGsの取組との関連性をお示ししています。</p>

        <BackBtn href={"/no162"} />
      </Content>
    </Page>
  )
}
export default Home
